import { isEmpty } from 'lodash';
import qs from 'qs';
import { QueryParamsDictionary } from './QueryParamsDictionary';

export function assembleUrl(url: string, queryParams: QueryParamsDictionary = {}) {
    if (!queryParams || isEmpty(queryParams)) {
        return url;
    }
    let completeUrl = url;
    if (queryParams) {
        completeUrl += `?${qs.stringify(queryParams, { skipNulls: true })}`;
    }
    return completeUrl;
}
